export default __webpack_public_path__ + "static/media/portadavideoconfiguracion6.9d3eca2a.png";